var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms"},[_c('q-scroll-area',{ref:"scrollArea",staticStyle:{"height":"800px"},attrs:{"thumb-style":_vm.thumbStyle}},[(_vm.tcsKey)?_c('tcs-box',{attrs:{"tcsKey":_vm.tcsKey}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }